import { useFeatureRollout } from '@rea-argonaut/experiment';
import type { FunctionComponent } from 'react';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapLinkIconPlacement } from '../../../app-kit/helpers/mapLinkIconPlacement';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { UpdatePropertyDetailsModal } from './UpdatePropertyDetailsModal';

interface UpdatePropertyDetailsModalWithDataProps {
  opened: boolean;
  onClose: () => void;
}

export const UpdatePropertyDetailsModalWithData: FunctionComponent<
  UpdatePropertyDetailsModalWithDataProps
> = ({ opened, onClose }) => {
  const mieleBanner = useFeatureRollout('miele_banner').isEnabled();
  const cachedPage = usePropertyPageQuery();

  let cta;

  if (mieleBanner) {
    cta =
      cachedPage?.data?.propertyPageBySlugV3?.propertyFeaturesV2?.keyFeatures?.updatePropertyDetails
        ?.cta;
    if (!cta?.modal) return null;
  } else {
    cta = cachedPage?.data?.propertyPageBySlugV3?.propertyFeaturesV2?.updatePropertyDetails?.cta;
    if (cta?.__typename !== 'PropertyPage_UpdatePropertyDetailsModalCta' || !cta.modal) return null;
  }

  const { subtitle, link } = cta.modal;
  const mappedLink = {
    ...link,
    variant: mapApiWeblinkVariantToLinkVariant(link.variant),
    iconInfo: link.iconInfo
      ? {
          name: link.iconInfo.name,
          placement: mapLinkIconPlacement(link.iconInfo.placement),
        }
      : null,
  };

  return (
    <UpdatePropertyDetailsModal
      opened={opened}
      onClose={onClose}
      subtitle={subtitle}
      link={mappedLink}
    />
  );
};
